'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'bulldozer';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e655';
var svgPathData = ['M32 400c0-30.5 12.2-58.2 32-78.4 20.3-20.7 48.6-33.6 80-33.6l224 0c41.5 0 77.7 22.5 97 56 9.5 16.5 15 35.6 15 56 0 61.9-50.1 112-112 112l-224 0C82.1 512 32 461.9 32 400zm64 0c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-224 0c-26.5 0-48 21.5-48 48z', 'M128 96l0 96 124.2 0-48-96-76.2 0zM261.5 67.4l62.3 124.6 28.2 0 0-72c0-13.3 10.7-24 24-24s24 10.7 24 24l0 74c27.6 7.1 48 32.2 48 62l0 40 80 0 0-80c0-48.6 39.4-88 88-88 13.3 0 24 10.7 24 24s-10.7 24-24 24c-22.1 0-40 17.9-40 40l0 208c0 22.1 17.9 40 40 40 13.3 0 24 10.7 24 24s-10.7 24-24 24c-48.6 0-88-39.4-88-88l0-80-63 0c-19.4-33.5-55.6-56-97-56l-224 0c-31.3 0-59.6 12.9-80 33.6 0-.5 0-1 0-1.6L64 80c0-26.5 21.5-48 48-48l92.2 0c24.2 0 46.4 13.7 57.2 35.4zM352 376a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM232 400a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm-72-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBulldozer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;